// material-ui
import { Box, Stack, Typography, Chip } from '@mui/material';
import { useGetCurrentUserModal } from 'api/currentUser';

// project imports
import { useGetMenuMaster } from 'api/menu';
import useTenant from 'hooks/useTenant';

// ==============================|| DRAWER - USER ||============================== //

export default function NavUser() {
  const CurrentUser = useGetCurrentUserModal();
  const currentUser = Array.isArray(CurrentUser) ? CurrentUser[0] : CurrentUser;
  const { branding } = useTenant();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  return (
    <Box
      sx={{
        p: 1.25,
        px: !drawerOpen ? 1.25 : 3,
        borderTop: '2px solid',
        borderTopColor: 'divider'
      }}
    >
      {drawerOpen ? (
        // Expanded footer
        <Stack spacing={0.5}>
          {/* Version Info */}
          <Stack spacing={0.5}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="caption" fontWeight={500} sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                {currentUser.data?.userType === 2 || currentUser.data?.userType === 4 && branding ? branding?.companyName :
                  "Private Provider Portal"} v1.0
              </Typography>
              <Chip
                label={import.meta.env.MODE === "production" ? "Prod" : "Staging"}
                size="small"
                variant="outlined"
                sx={{
                  fontSize: '0.7rem',
                  px: 0.2,
                  marginLeft: 0.5,
                  height: 20
                }}
              />
            </Stack>

            <Typography variant="caption" color="text.secondary">
              © {new Date().getFullYear()} All rights reserved
            </Typography>
          </Stack>

        </Stack>
      ) : (
        // Collapsed footer
        <Stack direction="column" alignItems="center" spacing={0.5}>
          <Chip
            label="v1.0"
            size="small"
            variant="outlined"
            sx={{
              fontSize: '0.65rem',
              px: 0.3,
              height: 18,
              borderRadius: '6px',
              fontWeight: 500,
              bgcolor: 'primary.50',
              borderColor: 'primary.200',
              '&:hover': {
                bgcolor: 'primary.100'
              }
            }}
          />
        </Stack>
      )}
    </Box>
  );
}
